import { render, staticRenderFns } from "./SimilarJobs.vue?vue&type=template&id=7b59e58a&"
import script from "./SimilarJobs.vue?vue&type=script&lang=js&"
export * from "./SimilarJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports